export const THEME_PREFERENCES = ["auto", "dark", "light"] as const;

export type ThemePreference = (typeof THEME_PREFERENCES)[number];
export type EffectiveTheme = "dark" | "light";

export const AUTO_THEME_FALLBACK_COLORS: Record<
  EffectiveTheme,
  { background: string; surface: string }
> = {
  dark: { background: "#0e1621", surface: "#17212b" },
  light: { background: "#f5f4ed", surface: "#ffffff" },
};

export const FIXED_THEME_COLORS: Record<
  EffectiveTheme,
  { background: string; surface: string }
> = {
  dark: { background: "#1e2d3c", surface: "#131e28" },
  light: { background: "#f5f4ed", surface: "#ffffff" },
};

export function normalizeThemePreference(
  value: unknown,
): ThemePreference | null {
  return THEME_PREFERENCES.includes(value as ThemePreference)
    ? (value as ThemePreference)
    : null;
}

export function initialThemePreference(
  storedValue: unknown,
): ThemePreference {
  // A saved choice (including the old dark default) always wins.
  return normalizeThemePreference(storedValue) ?? "auto";
}

export function resolveEffectiveTheme(
  preference: ThemePreference,
  telegramTheme: EffectiveTheme | null,
  systemPrefersDark: boolean,
): EffectiveTheme {
  if (preference !== "auto") {
    return preference;
  }
  return telegramTheme ?? (systemPrefersDark ? "dark" : "light");
}
